<template>
    <div class="votesrecord-body">
        <van-tabs v-model="active">
          <!-- <van-tab title="展示类"><List :List="compare"/></van-tab>
          <van-tab title="运动类"><List :List="rope"/></van-tab> -->
          <!-- <van-tab title="挑战卡路里"><List :List="calorie"/></van-tab> -->
          <van-tab title="我的视频"><List :List="vote"/></van-tab>
        </van-tabs>
        <!-- <van-popup v-model="show" closeable :style="{ height: '100%',width: '100%' }" :close-icon="require('assets/img/common/colse.svg')">
            <video
              id="video" 
              class="video" 
              :src="mediaurl"
              controls = "true"
              :poster="imgurl"
              preload="auto" 
              webkit-playsinline="true" 
              playsinline="true"
              x-webkit-airplay="allow" 
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              style="object-fit:fill">
            </video> 
        </van-popup> -->
    </div>
</template>
<script>
    import {Popup,Tab, Tabs} from 'vant'
    import List from './List/index'
    import './index.less'

    export default {
        name: "myvotes",
        components: {
            vanTab:Tab,
            vanTabs:Tabs,
            vanPopup:Popup,
            List
        },
        data() {
            return {
                page: 1,
                calorie: [],
                compare: [],
                rope: [],
                vote: [],
                show:false,
                imgurl:'',
                mediaurl:'',
                active: 0
            }
        },
        methods: {
            showVideo: function (e) {
                window.location.href = e;
            },
            onLoad() {
                this.getList()
            },
            getList() {
                this.$api.mwap.myVideos().then((res) => {
                    if (res.status * 1 === 200) {
                        this.calorie = res.data.calorie
                        this.vote = res.data.vote
                    }
                })
            },
            gotouch(item) {
                this.show = true
                this.imgurl = item.mediaurl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto'
                this.mediaurl = item.mediaurl
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused) 
                //   myVideo.play(); 
                // else 
                //   myVideo.pause(); 
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getList();
            })
        }
    }
</script>